import { PromptRevision } from "@/api/prompts-types";
import { Link } from "@/components/ui/Link";
import { usePromptById } from "@/queries/prompts/use-prompt-by-id";
import { timestampColumns } from "@/utils/datagrid-utils";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack/Stack";
import { DataGrid } from "@mui/x-data-grid/DataGrid/DataGrid";
import { GridColDef } from "@mui/x-data-grid/models/colDef/gridColDef";
import { useMemo } from "react";

type Props = {
  promptId: string | undefined;
};

const getColumns: (
  promptId: string | undefined,
) => GridColDef<PromptRevision>[] = (promptId) => [
  {
    field: "id",
    headerName: "Revision ID",
    width: 120,
    filterable: false,
    renderCell: (params) => (
      <Link
        to={`/prompts/${promptId}/revisions/${params.row.revision}`}
        onClick={() => window.scrollTo(0, 0)}
      >
        {params.row.id}
      </Link>
    ),
  },
  {
    field: "revision",
    headerName: "Revision",
    width: 90,
  },
  {
    field: "revisionNote",
    headerName: "Revision Note",
    width: 300,
  },
  ...timestampColumns<PromptRevision>(),
];

export function Revisions({ promptId }: Props) {
  const { data: prompt } = usePromptById(promptId);

  const columns = useMemo(() => getColumns(promptId), [promptId]);

  if (!prompt) {
    return null;
  }

  const revisions = prompt.revisions.toSorted(
    (r1, r2) => r1.revision - r2.revision,
  );

  return (
    <Stack gap={2}>
      <Typography variant="h6">All Revisions</Typography>
      <DataGrid
        rowHeight={46}
        columnHeaderHeight={46}
        columns={columns}
        rows={revisions}
      />
    </Stack>
  );
}
